module.exports = __webpack_public_path__ + "static/media/S (105).57b5e7ba.jpg";